// Softer, larger-radius shadows in a cool grey rather than the previous warm near-black.
// The old set used rgba(63,63,68,...) and rgba(0,0,0,0.31) with tight blur, which reads as
// a hard drop shadow; modern surfaces sit on a wider, lighter spread.
//
// MUI requires exactly 25 entries, index 0 being 'none'.

export default [
  'none',
  '0 0.85px 2.4px rgba(15, 23, 42, 0.054), 0 1.7px 4.8px rgba(15, 23, 42, 0.045)',
  '0 1.2px 3.3px rgba(15, 23, 42, 0.058), 0 2.4px 6.6px rgba(15, 23, 42, 0.05)',
  '0 1.55px 4.2px rgba(15, 23, 42, 0.062), 0 3.1px 8.4px rgba(15, 23, 42, 0.055)',
  '0 1.9px 5.1px rgba(15, 23, 42, 0.066), 0 3.8px 10.2px rgba(15, 23, 42, 0.06)',
  '0 2.25px 6.0px rgba(15, 23, 42, 0.07), 0 4.5px 12.0px rgba(15, 23, 42, 0.065)',
  '0 2.6px 6.9px rgba(15, 23, 42, 0.074), 0 5.2px 13.8px rgba(15, 23, 42, 0.07)',
  '0 2.95px 7.8px rgba(15, 23, 42, 0.078), 0 5.9px 15.6px rgba(15, 23, 42, 0.075)',
  '0 3.3px 8.7px rgba(15, 23, 42, 0.082), 0 6.6px 17.4px rgba(15, 23, 42, 0.08)',
  '0 3.65px 9.6px rgba(15, 23, 42, 0.086), 0 7.3px 19.2px rgba(15, 23, 42, 0.085)',
  '0 4.0px 10.5px rgba(15, 23, 42, 0.09), 0 8.0px 21.0px rgba(15, 23, 42, 0.09)',
  '0 4.35px 11.4px rgba(15, 23, 42, 0.094), 0 8.7px 22.8px rgba(15, 23, 42, 0.095)',
  '0 4.7px 12.3px rgba(15, 23, 42, 0.098), 0 9.4px 24.6px rgba(15, 23, 42, 0.1)',
  '0 5.05px 13.2px rgba(15, 23, 42, 0.1), 0 10.1px 26.4px rgba(15, 23, 42, 0.105)',
  '0 5.4px 14.1px rgba(15, 23, 42, 0.1), 0 10.8px 28.2px rgba(15, 23, 42, 0.11)',
  '0 5.75px 15.0px rgba(15, 23, 42, 0.1), 0 11.5px 30.0px rgba(15, 23, 42, 0.115)',
  '0 6.1px 15.9px rgba(15, 23, 42, 0.1), 0 12.2px 31.8px rgba(15, 23, 42, 0.12)',
  '0 6.45px 16.8px rgba(15, 23, 42, 0.1), 0 12.9px 33.6px rgba(15, 23, 42, 0.12)',
  '0 6.8px 17.7px rgba(15, 23, 42, 0.1), 0 13.6px 35.4px rgba(15, 23, 42, 0.12)',
  '0 7.15px 18.6px rgba(15, 23, 42, 0.1), 0 14.3px 37.2px rgba(15, 23, 42, 0.12)',
  '0 7.5px 19.5px rgba(15, 23, 42, 0.1), 0 15.0px 39.0px rgba(15, 23, 42, 0.12)',
  '0 7.85px 20.4px rgba(15, 23, 42, 0.1), 0 15.7px 40.8px rgba(15, 23, 42, 0.12)',
  '0 8.2px 21.3px rgba(15, 23, 42, 0.1), 0 16.4px 42.6px rgba(15, 23, 42, 0.12)',
  '0 8.55px 22.2px rgba(15, 23, 42, 0.1), 0 17.1px 44.4px rgba(15, 23, 42, 0.12)',
  '0 8.9px 23.1px rgba(15, 23, 42, 0.1), 0 17.8px 46.2px rgba(15, 23, 42, 0.12)',
];
